<template>
  <div class="wrapper">
    <div class="container">
      <van-popup v-model="areaShow" :lock-scroll="true">
        <div class="areaPopup">
          <div class="areaTitle">可用{{areaTitle}}</div>
          <span class="areaText">{{areaText}}</span>
        </div>
      </van-popup>
      <van-tabs sticky animated color="#E52B25"  :line-width="20" :swipeable="true" v-model="active">
        <van-tab :title="`未使用(${menu[0].totalRows})`">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              id="scroll"
              :immediate-check="false"
              v-model="menu[0].loading&&active==0"
              :finished="menu[0].finished"
              :offset="20"
              @load="getdata"
            >
              <div class="no" v-if="menu[0].list.length == 0&&!menu[0].loading">
                <img src="./../../assets/images/myCoupon/Bitmap.png" alt />
                <div>您当前还没有优惠券哦~</div>
                <!--<br>去领券中心看看吧！-->
                <!--<router-link to="/securities">-->
                  <!--<span>领券中心</span>-->
                <!--</router-link>-->
              </div>
              <div
                class="couponbox"
                v-for="(item,index) in menu[0].list"
                :key="index"
              >
                <!-- 分割线 -->
                <div class="line">
                  <div class="circle c_t"></div>
                  <div class="circle c_b"></div>
                </div>
                <div class="leftCircle">
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                </div>
                <div class="rightCircle">
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                </div>
                <!-- 左侧满减券 -->
                <div class="left" v-if="item.limit_condition !=0">
                  <!-- 减得金额 -->
                  <div class="top">
                    <span class="icon red">￥</span>
                    <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                  </div>
                  <div class="bot">
                    满{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}元使用
                  </div>
                </div>
                <!-- 左侧无门槛券 -->
                <div class="left" v-if="item.limit_condition==0">
                  <!-- 减得金额 -->
                  <div class="top">
                    <span class="icon red">￥</span>
                    <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                  </div>
                  <div class="bot">无门槛券</div>
                </div>
                <div class="mid" @click="showArea(item)">
                  <span class="top">{{item.name}}</span>
                  <span class="bot" v-if="item.start_time_result==0">{{item.end_time}} 到期</span>
                  <span class="bot" v-else>{{item.start_time}}<br>-{{item.end_time}}</span>
                  <span class="area" v-if="item.area_name">
                    限定专场可用<img src="./../../assets/images/myCoupon/fill2.png" alt="">
                  </span>
                  <span class="area" v-if="item.commodity_name">
                    限定商品可用<img src="./../../assets/images/myCoupon/fill2.png" alt="">
                  </span>
                </div>
                <div class="right">
                  <span class="notice due" v-if="item.is_end==1">即将到期</span>
                  <span class="notice due2" v-if="item.is_start==1">新增券</span>
                  <span class="usebtn" @click="use">使用</span>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab :title="`已使用(${menu[1].totalRows})`">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              id="scroll"
              :immediate-check="false"
              v-model="menu[1].loading&&active==1"
              :finished="menu[1].finished"
              :offset="20"
              @load="getdata"
            >
              <div class="no" v-if="menu[1].list.length == 0&&!menu[1].loading">
                <img src="./../../assets/images/myCoupon/Bitmap.png" alt />
                <div>您当前无已使用优惠券</div>
              </div>
              <div
                class="couponbox grey"
                v-for="(item,index) in menu[1].list"
                :key="index"
              >
                <!-- 分割线 -->
                <div class="line">
                  <div class="circle c_t"></div>
                  <div class="circle c_b"></div>
                </div>
                <div class="leftCircle">
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                </div>
                <div class="rightCircle">
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                </div>
                <!-- 左侧满减券 -->
                <div class="left" v-if="item.limit_condition !=0">
                  <!-- 减得金额 -->
                  <div class="top">
                    <span class="icon red">￥</span>
                    <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                  </div>
                  <div class="bot">
                    满{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}元使用
                  </div>
                </div>
                <!-- 左侧无门槛券 -->
                <div class="left" v-if="item.limit_condition==0">
                  <!-- 减得金额 -->
                  <div class="top">
                    <span class="icon red">￥</span>
                    <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                  </div>
                  <div class="bot">无门槛券</div>
                </div>
                <div class="mid" @click="showArea(item)">
                  <span class="top">{{item.name}}</span>
                  <span class="bot" v-if="item.start_time_result==0">{{item.end_time}} 到期</span>
                  <span class="bot" v-else>{{item.start_time}}<br>-{{item.end_time}}</span>
                  <span class="area" v-if="item.area_name">
                    限定专场可用<img src="./../../assets/images/myCoupon/fill1.png" alt="">
                  </span>
                  <span class="area" v-if="item.commodity_name">
                    限定商品可用<img src="./../../assets/images/myCoupon/fill2.png" alt="">
                  </span>
                </div>
                <div class="right">
                  <img src="./../../assets/images/myCoupon/isused.png" alt="">
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab :title="`已过期(${menu[2].totalRows})`">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              id="scroll"
              :immediate-check="false"
              v-model="menu[2].loading&&active==2"
              :finished="menu[2].finished"
              :offset="20"
              @load="getdata"
            >
              <div class="no" v-if="menu[2].list.length == 0&&!menu[2].loading">
                <img src="./../../assets/images/myCoupon/Bitmap.png" alt />
                <div>您当前无已过期优惠券</div>
              </div>
              <div
                class="couponbox grey"
                v-for="(item,index) in menu[2].list"
                :key="index"
              >
                <!-- 分割线 -->
                <div class="line">
                  <div class="circle c_t"></div>
                  <div class="circle c_b"></div>
                </div>
                <div class="leftCircle">
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                </div>
                <div class="rightCircle">
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                  <div class="circle1"></div>
                </div>
                <!-- 左侧满减券 -->
                <div class="left" v-if="item.limit_condition !=0">
                  <!-- 减得金额 -->
                  <div class="top">
                    <span class="icon red">￥</span>
                    <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                  </div>
                  <div class="bot">
                    满{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}元使用
                  </div>
                </div>
                <!-- 左侧无门槛券 -->
                <div class="left" v-if="item.limit_condition==0">
                  <!-- 减得金额 -->
                  <div class="top">
                    <span class="icon red">￥</span>
                    <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                  </div>
                  <div class="bot">无门槛券</div>
                </div>
                <div class="mid" @click="showArea(item)">
                  <span class="top">{{item.name}}</span>
                  <span class="bot" v-if="item.start_time_result==0">{{item.end_time}} 到期</span>
                  <span class="bot" v-else>{{item.start_time}}<br>-{{item.end_time}}</span>
                  <span class="area" v-if="item.area_name">
                    限定专场可用<img src="./../../assets/images/myCoupon/fill1.png" alt="">
                  </span>
                  <span class="area" v-if="item.commodity_name">
                    限定商品可用<img src="./../../assets/images/myCoupon/fill2.png" alt="">
                  </span>
                </div>
                <div class="right">
                  <img src="./../../assets/images/myCoupon/istimed.png" alt="">
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>

      <!-- 历史优惠券 -->
      <!-- <div class="historybox" v-show="this.type==0">
        <router-link to="couponhistory">
          <van-button class="histxt" round type="default" size="small">优惠券历史记录</van-button>
        </router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      isLoading: false,
      myCouponsList: [],
      numPerPage: 10,
      active: 0, //初始显示那个类
      areaShow:false,
      areaText:'',
      areaTitle:'',
      menu: [
        {
          list: [],
          pageIndex: 0,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        },
        {
          list: [],
          pageIndex: 0,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        },
        {
          list: [],
          pageIndex: 0,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        }
      ],
    };
  },
  watch: {
    active(val, old) {
      this.menu[0].list = [];
      this.menu[1].list = [];
      this.menu[2].list = [];
      this.menu[val].pageIndex = 0;
      this.menu[val].loading = true;
      this.menu[val].finished = false;
      this.getdata();
    }
  },
  computed: {
    ...mapGetters(["coupon"])
  },
  methods: {
    onRefresh() {
      this.menu[this.active].pageIndex = 0;
      this.menu[this.active].finished = false;
      this.menu[this.active].list = [];
      this.getdata();
    },
    /**
     * 去使用优惠券
     * @param
     */
    use() {
      this.$router.push({ path: "/index", query:{supNbr:this.userInfo.nbr} });
    },
    getMyCoupon() {
      this.$commonPost({
        jydm: "flow_70131",
        flow_70131: {
          user_nbr: this.userInfo.nbr,
          is_use: this.active,
          page_index: this.menu[this.active].pageIndex * this.numPerPage,
          num_per_page: this.numPerPage
        }
      })
        .then(response => {
          let arr = [];
          if(response.unuse_total_rows){
            this.menu[0].totalRows= response.unuse_total_rows;
          }
          if(response.use_total_rows){
            this.menu[1].totalRows= response.use_total_rows;
          }
          if(response.expired_total_rows){
            this.menu[2].totalRows= response.expired_total_rows;
          }
          if (response.couponlist) {
            if (response.couponlist.length > 0) {
              arr = response.couponlist;
            } else {
              arr.push(response.couponlist);
            }
            this.menu[this.active].list= this.menu[this.active].list.concat(arr);
            if (response.total_rows == this.menu[this.active].list.length) {
              this.menu[this.active].finished = true;
            } else {
              this.menu[this.active].pageIndex += 1;
              this.menu[this.active].finished = false;
            }
            this.isLoading = false;
            this.menu[this.active].loading = false;
          } else {
            this.menu[this.active].finished = true;
            this.isLoading = false;
            this.menu[this.active].loading = false;
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.menu[this.active].loading = false;
          this.menu[this.active].finished = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getdata() {
      this.menu[this.active].loading = true; //手动控制上啦正在加载，防止多次请求
      this.getMyCoupon();
    },
    showArea(item){
      if(item.commodity_name){
        this.areaShow = true;
        this.areaTitle = '商品'
        this.areaText = item.commodity_name;
      }
      if(item.area_name){
        this.areaShow = true;
        this.areaTitle = '专场'
        this.areaText = item.area_name;
      }
    },
    initPage(){
      let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
      this.getdata();
    }
  },
  created() {
    document.title = "我的优惠券";
    this.initPage()
  },
  mounted() {}
};
</script>
<style scoped lang='stylus'>
.container >>> .van-tab{
  font-size:.28rem;
  color: #333;
}
.container >>> .van-tab--active {
  font-weight: normal !important;
  color: #E52B25;
}
.wrapper >>> .van-pull-refresh__track {
  min-height: calc(100vh - 1.36rem);
}

.wrapper >>> .no {
  margin: 0 auto 0;
  padding-top: 1.86rem;
  text-align: center;
}
.wrapper >>> .no img{
  width:2.94rem;
  height:1.78rem;
}
.wrapper >>> .no div{
  font-size:.28rem;
  color:#999;
  margin-top:.3rem;
  line-height:.4rem;
}
.wrapper >>> .no span{
  margin-top:.6rem;
  width:5.92rem;
  height:1.4rem;
  border: 2px solid #E52B25;
  border-radius: .8rem;
  display:inline-block;
  color:#E52B25;
  line-height:1.4rem;
  text-align:center;
  font-size:.6rem;
  transform:scale(0.5);
  transform-origin: top;
}
.wrapper >>> .van-popup {
  border-radius:0.2rem;
}
</style>
<style scoped lang='less'>
.wrapper {
  width: 100%;
}
.areaPopup{
  width: 5.92rem;
  height: 3.34rem;
  background: #fff;
  .areaTitle{
   text-align: center;
   line-height: 0.5rem;
   margin-top: 0.4rem;
   margin-bottom: 0.54rem;
   font-size: 0.36rem;
   font-weight: bold;
  }
  .areaText{
    padding-left: .3rem;
    padding-right: 0.3rem;
   font-size: 0.28rem;
   line-height: 0.4rem;
  }
}
.container {
  min-height: 100vh;
  background: #f5f5f5;
  box-sizing: border-box;
}

.couponbox {
  width: 6.9rem;
  height: 1.88rem;
  background: #fff;
  display: flex;
  position: relative;
  margin-bottom: 0.18rem;
  box-sizing: border-box;
  // border-radius: 0.2rem;
  &:last-child{
    margin-bottom: 0;
  }
}
#scroll{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: .3rem;
  padding-bottom: .3rem;
}

/* left */
.couponbox .left {
  width: 2.16rem;
  display: flex;
  height: 100%;
  height: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing:border-box;
  background-image: linear-gradient(-135deg, #FA5B4D 0%, #FF0E45 100%);
}

.couponbox .left .top {
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-family: 700;
  font-size: 0.6rem;
  margin-bottom: 0.16rem;
  color: #fff;
}

.couponbox .left .top .icon {
  font-size: 0.3rem;
  font-family: 700;
}

.couponbox .left .top .icon.red {
  font-weight: bold;
}

.couponbox .left .bot {
  font-size: 0.22rem;
  color: #fff;
}

/* 线 */
.line {
  width: 0.02rem;
  position: absolute;
  left: 2.06rem;
  z-index: 4;
  height: 100%;
}
.leftCircle{
  width: 0.02rem;
  position: absolute;
  left: -.09rem;
  z-index: 4;
  height: 100%;
}
.rightCircle{
  width: 0.02rem;
  position: absolute;
  right: .09rem;
  z-index: 4;
  height: 100%;
}

.circle {
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 50%;
  background: #f5f5f5;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.circle1 {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 50%;
  background: #f5f5f5;
  margin-top: .12rem;
}

.line .c_t {
  top: -0.1rem;
}

.line .c_b {
  bottom: -0.1rem;
}

/* mid */
.couponbox .mid {
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  padding-left: .28rem;
}

.mid .top {
  font-size: 0.28rem;
  color: #333333;
  font-weight: bold;
  margin-bottom: 0.14rem;
  line-height: .4rem;
  width: 3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.area{
  font-size: 0.2rem;
  color: #333;
  line-height: .3rem;
  margin-top:.1rem;
  display: flex;
  align-items: center;
  padding: 0;
  img{
    width: 0.24rem;
    height: 0.24rem;
    margin-left: .06rem;
  }
}
.mid .bot {
  font-size: 0.22rem;
  color: #999999;
  line-height: .3rem;
}

/* right */
.couponbox.grey{
  *{
    color: #ccc !important;
  }
  .left .icon,.left .money,.left .bot{
    color: #fff !important;
  }
  .left{
    background: #ddd !important;
  }
}
.couponbox .right {
  width: 1.56rem;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  img{
    width: 1rem;
    height: 1rem;
  }
}
.notice{
  width: 1.92rem;
  height: 0.56rem;
  position: absolute;
  font-size: .4rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .08rem;
  top: .1rem;
  transform: scale(0.5);
  transform-origin: top;
}
.due{
  background: #E52B25;
}
.due2{
  background: #5C71FD;
}
.selectBtn{
 width: 100%;
 box-sizing:border-box;
 padding-right: .29rem;
 display: flex;
 justify-content: flex-end;
 img{
   width: .4rem !important;
   height: 0.4rem !important;
 }
}
.usebtn {
  background-image: linear-gradient(-139deg, #FDB16F 0%, #FF610B 100%);
  border-radius: 0.48rem;
  display: flex;
  height: 0.8rem;
  width: 2.08rem;
  font-size: 0.56rem;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  transform: scale(0.5);
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/information/coupon.vue